import React from 'react';
import Button from 'client/component-library/buttons/ButtonAdmin/afsButton';

interface DealActionButtonsProps {
  onPublish: () => void;
  onReject: () => void;
  onSkip: () => void;
  disablePublish?: boolean;
  // Rendered directly under Publish (the Update menu).
  updateSlot?: React.ReactNode;
}

export const DealActionButtons = ({
  onPublish,
  onReject,
  onSkip,
  disablePublish = false,
  updateSlot = null,
}: DealActionButtonsProps) => {
  return (
    <div className="w-2/12 px-1">
      <div className="p-2">
        <Button
          onClick={onPublish}
          disabled={disablePublish}
          data-test="publish-deal-button"
        >
          Publish
        </Button>
      </div>
      {updateSlot && <div className="px-2 pb-2">{updateSlot}</div>}
      <div className="flex flex-col mx-2 border-t">
        <div className="pt-2 flex-1">
          <Button
            onClick={onReject}
            theme="danger"
            data-test="reject-deal-button"
          >
            Reject
          </Button>
        </div>
        <div className="pt-2 flex-1">
          <Button onClick={onSkip} theme="gray" data-test="skip-deal-button">
            Skip
          </Button>
        </div>
      </div>
    </div>
  );
};
